
/**
 * the possible n.message values for mobile notifications
 */
export const mobileMessages = ['com.vapps.vipro.extended.MobileNotificationPosted']
export const mobilePolicyPrefix = 'Mobile-'
export const readOnlyPropertyName = 'readOnlyWithComment'

// special event types
export const eventTypeConversationScreenScraped = 'ConversationScreenScraped'